import { secureApi } from './secureApi';

// Read-only history of the automated check-in message for a booking (ops "Messages" section).
// JWT-authenticated via secureApi. Response: { success: true, messages: [...], count: N }.
//
// GET /api/v1/checkin-messages/:bookingId
const checkinMessageApi = {
  list: async (bookingId) => {
    const response = await secureApi.get(`/api/v1/checkin-messages/${bookingId}`);
    return response.data;
  },

  // Stateless monitoring audit for the ops dashboard card (checkin-message-monitoring.md).
  // Recomputes overdue / failed / stuck-code bookings on each call. Response:
  // { success, generatedAt, globalOff, counts, overdue, failed, stuckCode, waitingForCode }.
  getMonitor: async () => {
    const response = await secureApi.get('/api/v1/checkin-messages/monitor');
    return response.data;
  }
};

export default checkinMessageApi;
